import "@/styles/icomoon.css";
import { theme } from "@/styles/theme";
import { ThemeProvider } from "@emotion/react";
import React, { ReactNode } from "react";
import { RecoilRoot } from "recoil";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { Swiper as RealSwiper } from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { Layout } from "./layout";

export interface WrapRootProps {
  element: ReactNode;
}

RealSwiper.use([Autoplay]);

export function WrapRoot({ element }: WrapRootProps) {
  return (
    <RecoilRoot>
      <ThemeProvider theme={theme}>
        <Layout>{element}</Layout>
      </ThemeProvider>
    </RecoilRoot>
  );
}
